export default "__VITE_ASSET__5a48e77b__"